import Optional from './Optional'
import {MessageProducer, ValidateIf} from '../validation-core'

export default function Required<T>(
    message?: string | MessageProducer<T>,
    validateIf?: ValidateIf<T>
) {
    return Optional<T>(false, message, validateIf)
}
